import React from "react";
import { useParams } from "react-router-dom";

import schools from "./assets/data/schools";

import MetaInfo from "./components/MetaInfo";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Banner from "./course-components/Banner";
import ProgrammeOverview from "./course-components/ProgrammeOverview";
import CurriculumStructure from "./course-components/CurriculumStructure";
import CourseWhyChoose from "./course-components/CourseWhyChoose";
import ProgramHighlights from "./course-components/ProgramHighlights";
import CourseEligibility from "./course-components/CourseEligibility";
import CourseCurriculumStructure from "./course-components/CourseCurriculumStructure";

import campusHero from "./course-details-assets/campus-hero.jpeg";
import classroomImage from "./course-details-assets/classroom.png";
import laboratoryImage from "./course-details-assets/laboratory.png";
import libraryImage from "./course-details-assets/library.png";
import seminarImage from "./course-details-assets/seminar-hall.png";
import studentLifeImage from "./course-details-assets/student-life.png";
import CourseSpecializations from "./course-components/CourseSpecializations";
import CourseSkills from "./course-components/CourseSkills";
import CourseOutcomes from "./course-components/CourseOutcomes";
import CareerOpportunities from "./course-components/CareerOpportunities";
import PlacementAssistance from "./course-components/PlacementAssistance";
import HigherStudies from "./course-components/HigherStudies";
import AdmissionProcess from "./course-components/AdmissionProcess";
import CourseFaqs from "./course-components/CourseFaqs";
import RelatedPrograms from "./course-components/RelatedPrograms";

const sampleCourse = {
  school: "School of Information & Technology",
  title: "Bachelor of Computer Applications (BCA)",
  shortTitle: "BCA",
  level: "Undergraduate",
  duration: "3 Years",
  mode: "Full Time",
  location: "ISBM University",
  eligibility:
    "10+2 or equivalent from a recognised board, subject to University norms.",
  intake: "As per University norms",
  heroImage: "",
  intro:
    "A future-focused undergraduate programme designed to develop computing knowledge, software capabilities, analytical thinking and practical technology skills for the digital economy.",
  overview:
    "The Bachelor of Computer Applications programme combines academic foundations with applied computing practice. Students develop an understanding of programming, databases, web technologies, software engineering, networks and contemporary digital systems through classroom learning, laboratory work, guided projects and career-oriented development.",
  advantages: [
    "Strong computing foundations",
    "Applied programming practice",
    "Project and laboratory learning",
    "Emerging technology exposure",
    "Communication and professional skills",
    "Higher-study and career pathways",
  ],
  programStructure: [
    { title: "Semester 1", credits: "22", marks: "550" },
    { title: "Semester 2", credits: "22", marks: "550" },
    { title: "Semester 3", credits: "22", marks: "550" },
    { title: "Semester 4", credits: "22", marks: "550" },
    { title: "Semester 5", credits: "22", marks: "550" },
    { title: "Semester 6", credits: "22", marks: "550" },
    { title: "Grand Total", credits: "176", marks: "4550" },
  ],
  curriculum: [
    {
      title: "Semester 1",
      subjects: [
        {
          title: "Media Sociology / Digital Media and Entrepreneurship",
          code: "BAJMC801T/BAJMC802T",
          credits: "10",
          ct: "50",
          ta: "25",
          ese: "175",
          practical: "-",
          total: "250",

        },
      ],
    },
    {
      title: "Semester 2",
      subjects: [
        {
          title: "Media Sociology / Digital Media and Entrepreneurship",
          code: "BAJMC801T/BAJMC802T",
          credits: "10",
          ct: "50",
          ta: "25",
          ese: "175",
          practical: "-",
          total: "250",

        },
      ],
    },
  ],
  outcomes: [
    "Apply computing concepts in practical contexts.",
    "Develop structured software solutions.",
    "Work with databases and digital systems.",
    "Understand networks and modern IT environments.",
    "Communicate technical ideas effectively.",
    "Prepare for technology careers and higher studies.",
  ],
  careers: [
    {
      title: "Software & Application Development",
      roles: ["Junior Developer", "Application Support", "QA Associate"],
    },
    {
      title: "Web & Digital Technology",
      roles: [
        "Web Developer",
        "Front-End Associate",
        "Digital Solutions Executive",
      ],
    },
    {
      title: "Data & Systems Support",
      roles: ["Database Support", "Junior Data Analyst", "IT Support"],
    },
    {
      title: "Higher Studies",
      roles: ["MCA", "M.Sc. IT", "Specialised Technology Programmes"],
    },
  ],
  admissions: [
    [
      "01",
      "Review Eligibility",
      "Check programme-specific eligibility and current admission guidelines.",
    ],
    [
      "02",
      "Apply Online",
      "Complete the online application with accurate personal and academic details.",
    ],
    [
      "03",
      "Submit Documents",
      "Provide the required academic and identity documents for verification.",
    ],
    [
      "04",
      "Counselling",
      "Receive programme and admission guidance from the University team.",
    ],
    [
      "05",
      "Confirm Admission",
      "Complete applicable admission formalities and fee payment.",
    ],
  ],
  faq: [
    {
      question: "Who can apply for this programme?",
      answer:
        "Applicants should have completed 10+2 or an equivalent examination from a recognised board, subject to current University eligibility requirements.",
    },
    {
      question: "Does the programme include practical learning?",
      answer:
        "Yes. The programme may include laboratory sessions, assignments, mini projects, presentations and major project work as prescribed in the academic structure.",
    },
    {
      question: "What career opportunities can I explore after graduation?",
      answer:
        "Graduates may explore entry-level opportunities in software, web technologies, application support, data support and IT services, or continue into relevant postgraduate programmes.",
    },
    {
      question: "Can I receive admission guidance before applying?",
      answer:
        "Yes. Prospective students may contact the admissions team for programme, eligibility and application guidance.",
    },
  ],
  relatedCourses: [
    {
      title: "B.Sc. (Hons) in Computer Science",
      level: "Undergraduate",
      duration: "3 Years",
      href: "/course/bsc-in-computer-science",
    },
    {
      title: "B.Sc. in Data Science",
      level: "Undergraduate",
      duration: "3 Years",
      href: "/course/bsc-in-data-science",
    },
    {
      title: "Master of Computer Applications",
      level: "Postgraduate",
      duration: "2 Years",
      href: "/course/master-of-computer-applications",
    },
  ],
  reasons: [
    {
      number: "01",
      title: "Industry-Relevant Curriculum",
      description:
        "Build knowledge through a curriculum designed to connect academic foundations with contemporary professional requirements.",
    },
    {
      number: "02",
      title: "Practical Learning",
      description:
        "Strengthen your understanding through projects, assignments, practical activities and application-oriented learning experiences.",
    },
    {
      number: "03",
      title: "Experienced Academic Guidance",
      description:
        "Learn with academic support focused on conceptual clarity, professional development and meaningful learning outcomes.",
    },
    {
      number: "04",
      title: "Career-Focused Development",
      description:
        "Develop communication, problem-solving and professional capabilities that support your progression towards future career opportunities.",
    },
  ],
  highlights: [
    {
      value: "Programme",
      label: "3 Years",
    },
    {
      value: "Full-Time",
      label: "Learning Mode",
    },
    {
      value: "Practical",
      label: "Learning Approach",
    },
    {
      value: "Career",
      label: "Focused Education",
    },
  ],
  specializations: [
    {
      title: "Software & Application Development",
      description:
        "Build deeper capabilities in programming, application development and modern software technologies.",
      focus: "Development",
    },
    {
      title: "Data & Analytics",
      description:
        "Develop analytical thinking and learn how data supports intelligent business and technology decisions.",
      focus: "Analytics",
    },
    {
      title: "Cloud & Digital Infrastructure",
      description:
        "Explore contemporary networks, cloud environments and the digital infrastructure powering modern organisations.",
      focus: "Infrastructure",
    },
  ]
};

const demoCourse = {
  title: "Master of Business Administration",
  shortName: "MBA",
  school: "School of Management",
  level: "Postgraduate",
  duration: "2 Years",
  mode: "Full Time",
  intake: "2026",
  images: {
    hero: campusHero,
    classroom: classroomImage,
    laboratory: laboratoryImage,
    library: libraryImage,
    seminar: seminarImage,
    studentLife: studentLifeImage,
  },
  overview:
    "The MBA programme builds strategic perspective, managerial confidence and practical business capability through contemporary coursework, case-led learning and industry engagement.",
  eligibility:
    "A recognised bachelor’s degree in any discipline with eligibility determined according to current University admission norms.",
  highlights: [
    ["Case-led learning", "Analyse business situations and defend decisions using evidence."],
    ["Industry exposure", "Learn through expert sessions, live briefs and professional interaction."],
    ["Applied projects", "Translate management concepts into measurable organisational solutions."],
    ["Career preparation", "Strengthen aptitude, communication, interviews and professional presence."],
  ],
  reasons: [
    "A curriculum connecting management foundations with emerging business practice.",
    "Faculty-guided learning through cases, simulations, presentations and projects.",
    "Opportunities to develop leadership, analytical judgement and enterprise thinking.",
    "Structured career assistance and exposure to contemporary professional expectations.",
  ],
  programStructure: [
    { title: "Semester 1", credits: "24", marks: "600" },
    { title: "Semester 2", credits: "24", marks: "600" },
    { title: "Semester 3", credits: "24", marks: "600" },
    { title: "Semester 4", credits: "24", marks: "600" },
    { title: "Grand Total", credits: "96", marks: "2400" },
  ],
  curriculum: [
    {
      title: "Semester 1",
      subjects: [
        ["Management Principles & Organisational Behaviour", "MBA101", "4", "20", "10", "70", "-", "100"],
        ["Managerial Economics", "MBA102", "4", "20", "10", "70", "-", "100"],
        ["Accounting for Managers", "MBA103", "4", "20", "10", "70", "-", "100"],
        ["Business Communication", "MBA104", "4", "20", "10", "50", "20", "100"],
        ["Quantitative Techniques", "MBA105", "4", "20", "10", "70", "-", "100"],
        ["Business Environment", "MBA106", "4", "20", "10", "70", "-", "100"],
      ],
    },
    {
      title: "Semester 2",
      subjects: [
        ["Marketing Management", "MBA201", "4", "20", "10", "70", "-", "100"],
        ["Financial Management", "MBA202", "4", "20", "10", "70", "-", "100"],
        ["Human Resource Management", "MBA203", "4", "20", "10", "70", "-", "100"],
        ["Operations Management", "MBA204", "4", "20", "10", "70", "-", "100"],
        ["Business Research Methods", "MBA205", "4", "20", "10", "50", "20", "100"],
        ["Management Information Systems", "MBA206", "4", "20", "10", "50", "20", "100"],
      ],
    },
    {
      title: "Semester 3",
      subjects: [
        ["Strategic Management", "MBA301", "4", "20", "10", "70", "-", "100"],
        ["Business Analytics", "MBA302", "4", "20", "10", "50", "20", "100"],
        ["Specialisation Elective I", "MBA3E1", "4", "20", "10", "70", "-", "100"],
        ["Specialisation Elective II", "MBA3E2", "4", "20", "10", "70", "-", "100"],
        ["Specialisation Elective III", "MBA3E3", "4", "20", "10", "70", "-", "100"],
        ["Summer Internship Project", "MBA306", "4", "20", "10", "-", "70", "100"],
      ],
    },
    {
      title: "Semester 4",
      subjects: [
        ["Entrepreneurship & Innovation", "MBA401", "4", "20", "10", "70", "-", "100"],
        ["Business Ethics & Corporate Governance", "MBA402", "4", "20", "10", "70", "-", "100"],
        ["Specialisation Elective IV", "MBA4E1", "4", "20", "10", "70", "-", "100"],
        ["Specialisation Elective V", "MBA4E2", "4", "20", "10", "70", "-", "100"],
        ["Specialisation Elective VI", "MBA4E3", "4", "20", "10", "70", "-", "100"],
        ["Dissertation / Capstone Project", "MBA406", "4", "20", "10", "-", "70", "100"],
      ],
    },
  ],
  specializations: [
    {
      title: "Software & Application Development",
      description:
        "Build deeper capabilities in programming, application development and modern software technologies.",
      focus: "Development",
    },
    {
      title: "Data & Analytics",
      description:
        "Develop analytical thinking and learn how data supports intelligent business and technology decisions.",
      focus: "Analytics",
    },
    {
      title: "Cloud & Digital Infrastructure",
      description:
        "Explore contemporary networks, cloud environments and the digital infrastructure powering modern organisations.",
      focus: "Infrastructure",
    },
  ],
  skills: [
    {
      title: "Problem Solving",
      description:
        "Analyse challenges, evaluate possibilities and develop practical solutions.",
    },
    {
      title: "Technical Proficiency",
      description:
        "Build confidence with relevant tools, technologies and professional methods.",
    },
    {
      title: "Analytical Thinking",
      description:
        "Interpret information and approach decisions with structured reasoning.",
    },
    {
      title: "Communication",
      description:
        "Express ideas clearly across academic, collaborative and professional settings.",
    },
    {
      title: "Team Collaboration",
      description:
        "Contribute effectively within multidisciplinary teams and project environments.",
    },
    {
      title: "Project Execution",
      description:
        "Plan responsibilities and transform ideas into structured project outcomes.",
    },
  ],
  outcomes: [
    {
      title: "Apply Knowledge",
      description:
        "Use programme concepts and principles confidently in practical and professional contexts.",
    },
    {
      title: "Analyse & Solve",
      description:
        "Evaluate challenges, interpret information and develop logical solutions.",
    },
    {
      title: "Work with Professional Tools",
      description:
        "Use relevant technologies, methods and practices associated with the discipline.",
    },
  ],
  careers: ["Management Consultant", "Business Analyst", "Marketing Manager", "Financial Analyst", "HR Manager", "Operations Manager", "Entrepreneur", "Product Manager"],
  higherStudies: ["Ph.D. in Management", "Executive education", "Professional finance certifications", "Business analytics certifications"],
  related: ["BBA", "B.Com", "MBA in Hospital Administration", "MBA in Logistics & Supply Chain"],
  placementSupport: [
    {
      number: "01",
      title: "Career Counselling",
      description:
        "Guidance to help students understand career directions, professional interests and opportunities relevant to their programme.",
    },
    {
      number: "02",
      title: "Skill Development",
      description:
        "Focused activities designed to strengthen communication, aptitude, professional behaviour and workplace readiness.",
    },
    {
      number: "03",
      title: "Resume & Profile Building",
      description:
        "Support for presenting academic achievements, projects, skills and experience through a professional career profile.",
    },
    {
      number: "04",
      title: "Interview Preparation",
      description:
        "Practice-oriented preparation through interview guidance, mock interactions and professional communication development.",
    },
    {
      number: "05",
      title: "Employer Engagement",
      description:
        "Opportunities to connect with organisations through placement activities and employer interactions, subject to eligibility.",
    },
  ],
  higherStudies: [
    {
      degree: "Master's Programme",
      field: "Advanced Study",
      description:
        "Progress towards postgraduate education in the same or a closely related academic discipline.",
    },
    {
      degree: "Specialised Master's",
      field: "Specialisation",
      description:
        "Build deeper expertise by pursuing postgraduate study in a specialised area related to the programme.",
    },
    {
      degree: "MBA / Management Studies",
      field: "Management",
      description:
        "Combine your domain knowledge with management, leadership and business-oriented education.",
    },
    {
      degree: "Professional Certification",
      field: "Professional Learning",
      description:
        "Develop additional capabilities through recognised certifications relevant to your chosen career direction.",
    },
    {
      degree: "Research Pathway",
      field: "Research",
      description:
        "Explore research-oriented postgraduate opportunities that can lead towards advanced academic study.",
    },
  ],
  relatedPrograms: [
    {
      title: "Bachelor of Computer Applications",
      level: "Undergraduate",
      duration: "3 Years",
      school: "School of Science",
      href: "/course/bca",
    },
    {
      title: "B.Sc. in Information Technology",
      level: "Undergraduate",
      duration: "3 Years",
      school: "School of Science",
      href: "/course/bsc-it",
    },
    {
      title: "Master of Computer Applications",
      level: "Postgraduate",
      duration: "2 Years",
      school: "School of Science",
      href: "/course/mca",
    },
    {
      title: "M.Sc. in Information Technology",
      level: "Postgraduate",
      duration: "2 Years",
      school: "School of Science",
      href: "/course/msc-it",
    },
  ],
  faqs: [
    {
      question: "Who can apply for this programme?",
      answer:
        "Applicants should satisfy the eligibility requirements prescribed for the programme.",
    },
    {
      question: "What is the duration of the programme?",
      answer:
        "Refer to the programme overview for the applicable duration and academic structure.",
    },
    {
      question: "Does the programme include practical learning?",
      answer:
        "Depending on the programme, learning may include projects, practical sessions, workshops, laboratory work or field exposure.",
    },
    {
      question: "What can I do after completing this programme?",
      answer:
        "Graduates may explore relevant careers, postgraduate study and specialised professional pathways.",
    },
    {
      question: "Does ISBM University provide placement assistance?",
      answer:
        "Career support may include guidance, skill development, interview preparation and employer engagement.",
    },
    {
      question: "How can I get help before applying?",
      answer:
        "Prospective students can connect with the admissions team for programme and application guidance.",
    },
  ],
  admissionProcess: [
    {
      title: "Explore the Programme",
      description:
        "Review programme information, curriculum and eligibility requirements.",
    },
    {
      title: "Check Eligibility",
      description:
        "Confirm that you meet the prescribed programme eligibility criteria.",
    },
    {
      title: "Submit Application",
      description:
        "Complete the University application form with the required information.",
    },
    {
      title: "Upload Documents",
      description:
        "Provide the required academic and supporting documents.",
    },
    {
      title: "Admission Review",
      description:
        "Your application is reviewed according to the admission procedure.",
    },
    {
      title: "Complete Admission",
      description:
        "Complete applicable admission formalities and fee payment.",
    },
  ],
};


const CourseDetails = () => {
  const { courseName } = useParams();

  // const currentSchool = schools.find((school) =>
  //   school.courses?.some((course) => course.name === courseName),
  // );

  // const course = currentSchool?.courses?.find(
  //   (course) => course.name === courseName,
  // );

  return (
    <>
      <MetaInfo schoolDetails="common" />

      <Header school="common" />

      <Banner course={demoCourse} />

      <ProgrammeOverview course={demoCourse} />

      <CourseWhyChoose course={demoCourse} />

      <ProgramHighlights course={demoCourse} />

      <CourseEligibility course={demoCourse} />

      <CourseCurriculumStructure course={demoCourse} />

      <CurriculumStructure course={demoCourse} />

      <CourseSpecializations course={demoCourse} />

      <CourseSkills course={demoCourse} />

      <CourseOutcomes course={demoCourse} />

      <CareerOpportunities course={demoCourse} />

      <PlacementAssistance course={demoCourse} />

      <HigherStudies course={demoCourse} />

      <AdmissionProcess course={demoCourse} />

      <CourseFaqs course={demoCourse} />

      <RelatedPrograms course={demoCourse} />

      <Footer />
    </>
  );
};

export default CourseDetails;
